<template>
  <el-popover
    width="200"
    ref="popperWrapper"
    popper-class="text-des-popper"
    trigger="hover"
    :open-delay="400"
    :disabled="!value"
  >
    <div class="des">
      <span>{{ value }}</span>
    </div>
    <template slot="reference">
      <slot name="reference"></slot>
    </template>
  </el-popover>
</template>
<script>
export default {
  name: "text-des-popper",
  props: {
    value: String
  }
}
</script>

<style lang="scss">
.text-des-popper {
  .des {
    color: #313132;
  }
}
</style>
